import type { TRuleWithTheme } from '@/styles/theme';

export const description: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
});
